// Marker for errors retrying cannot fix (auth failures, 4xx). Infrastructure-
// level so retry policies can honour it without importing feature modules.
export class NonRetriableError extends Error {
  statusCode: string;

  constructor(statusCode: string, message?: string) {
    super(message);
    this.name = 'NonRetriableError';
    this.statusCode = statusCode;
    // Restore the prototype chain so `instanceof` works after transpilation.
    Object.setPrototypeOf(this, NonRetriableError.prototype);
  }
}
